import { motion } from 'framer-motion'
import { 
  HomeModernIcon, 
  BriefcaseIcon, 
  HeartIcon, 
  UserGroupIcon 
} from '@heroicons/react/24/outline'

const personas = [
  { icon: HomeModernIcon, gradient: 'from-primary-500 to-primary-600' },
  { icon: BriefcaseIcon, gradient: 'from-orange-500 to-primary-500' },
  { icon: HeartIcon, gradient: 'from-primary-500 to-pink-500' },
  { icon: UserGroupIcon, gradient: 'from-primary-600 to-purple-500' }
]

export default function WhoItsFor({ t }) {
  return (
    <section className="section-padding bg-warm-cream">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-display font-bold text-neutral-900">
            {t.whoItsFor.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {Object.keys(t.whoItsFor).filter(key => key.startsWith('persona')).map((personaKey, index) => {
            const persona = t.whoItsFor[personaKey]
            const Icon = personas[index].icon
            const gradient = personas[index].gradient
            
            return (
              <motion.div
                key={personaKey}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="card hover:shadow-2xl transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div className={`bg-gradient-to-br ${gradient} rounded-2xl p-4 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-neutral-900 mb-3">
                      {persona.title}
                    </h3>
                    <p className="text-neutral-600 leading-relaxed">
                      {persona.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            )
          })}
        </div>

        {/* Bottom Message */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-12 max-w-3xl mx-auto"
        >
          <p className="text-lg text-neutral-600 italic">
            {t.whoItsFor.title === '誰のため？' 
              ? 'あなたが一人暮らしをしていても、誰かがあなたのことを気にかけています。' 
              : 'Whether you live alone or just want someone to know you\'re safe.'}
          </p>
        </motion.div>
      </div>
    </section>
  )
}
